import { Grid, Typography } from '@mui/material';
import React from 'react';
import { observer } from 'mobx-react-lite';

import { Fieldset } from '../../../../../../shared/ui/form/fieldset/FieldsetContainer';
import { useFourthStageVm } from './useFourthStage.vm';
import { Input } from '../../../../../../shared/ui/form/input/Input';
import { TextareaContainer } from '../../../CaseDraft.styled';
import { ButtonsActions } from '../buttonsActions/ButtonsActions';
import { ModalPublishedCase } from './modalPublishedCase/ModalPublishedCase';
import { useParams } from 'react-router-dom';

export const FourthStage = observer(() => {
  const { formik, handleDraftSave, handleSave, handleModalOpen, open, handleClose, finishMessage } = useFourthStageVm();
  const params = useParams();

  const isCushing = params && params?.type?.includes('cushing') && params?.version?.includes('v2');
  return (
    <Grid container justifyContent={'space-between'}>
      <Fieldset size={'l'} legend={'Podsumowania / wnioski'}>
        <TextareaContainer>
          <Input
            InputLabelProps={{ shrink: true }}
            multiline={true}
            rows={5}
            name={'summary'}
            type={'text'}
            onChange={formik.handleChange}
            value={formik.values.summary}
            label={'Wpisz wnioski / podsumowanie'}
          />
        </TextareaContainer>
      </Fieldset>
      {isCushing && (
        <Grid item xs={12} display={'flex'} justifyContent={'flex-end'} mt={2}>
          <Typography variant="caption" color={'rgba(0,0,0,0.6)'}>
            PL-IST-0068
          </Typography>
        </Grid>
      )}
      <ButtonsActions
        handleDraftSave={handleDraftSave}
        handleSave={handleModalOpen}
        nextStep={'Zapisz i przejdź dalej'}
      />
      {open && (
        <ModalPublishedCase
          finishMessage={finishMessage}
          open={open}
          handleClose={handleClose}
          handleDraftSave={handleDraftSave}
          handleSave={handleSave}
        />
      )}
    </Grid>
  );
});
